import { ChangeDetectionStrategy, Component, inject, Input, type SimpleChanges, type OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import type { Widgets } from '@common/enums';
import { ETariffAbbr } from '@common/enums';
import { tariffsCssClasses } from '@web/core/constants/tariff.const';

@Component({
    selector: 'web-paid-access-notification',
    templateUrl: './paid-access-notification.component.html',
    styleUrls: ['./paid-access-notification.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TranslateModule],
})
export class PaidAccessNotificationComponent implements OnChanges {
    @Input() widgetName: Widgets;
    @Input() nextTariff: ETariffAbbr;
    @Input() isEduSite: boolean;

    public readonly translateService: TranslateService = inject(TranslateService);

    public readonly ETariffAbbr = ETariffAbbr;
    public nextTariffTranslation: string;

    public get getTariffCssClass(): string {
        return tariffsCssClasses[this.nextTariff] || '';
    }

    ngOnChanges(changes: SimpleChanges): void {
        const { nextTariff } = changes;

        if (!nextTariff || nextTariff.previousValue === nextTariff.currentValue) {
            return;
        }

        this.nextTariffTranslation = this.translateService.instant(this.nextTariff);
    }
}
